import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=0391d65d&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=0391d65d&lang=stylus&scoped=true&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391d65d",
  null
  
)

export default component.exports